import { PROPERTY_OPPORTUNITIES_NAMES, PROPERTY_STRATEGIES_NAME, PROPERTY_TYPES } from '@constants';
class BestOpportunity {
    id;
    name;
    type;
    investmentStrategy;
    description;
    hasVariableIncome;
    numberOfBricksOwned;
    estimatedCapitalGain;
    estimatedAnnualProfit;
    capRate;
    thumbnailURL;
    createdAt;
    opportunityType;
    stabilizationDate;
    highlights;
    address;
    photos;
    rentalUnits;
    rents;
    annualLeasing;
    annualIncome;
    currentAnnualProfit;
    prices;
    bricks;
    bricksOnSaleByInvestor;
    maximumBricksToBuy;
    constructor(opportunity) {
        this.id = opportunity.id;
        this.name = opportunity.name;
        this.type = opportunity.type;
        this.investmentStrategy = opportunity.investmentStrategy;
        this.description = opportunity.description;
        this.hasVariableIncome = opportunity.hasVariableIncome;
        this.numberOfBricksOwned = opportunity.numberOfBricksOwned;
        this.estimatedCapitalGain = opportunity.estimatedCapitalGain;
        this.estimatedAnnualProfit = opportunity.estimatedAnnualProfit;
        this.capRate = opportunity.capRate;
        this.thumbnailURL = opportunity.thumbnailURL;
        this.createdAt = opportunity.createdAt;
        this.opportunityType = opportunity.opportunityType;
        this.stabilizationDate = opportunity.stabilizationDate;
        this.highlights = opportunity.highlights;
        this.address = opportunity.address;
        this.photos = opportunity.photos;
        this.rentalUnits = opportunity.rentalUnits;
        this.rents = opportunity.rents;
        this.annualLeasing = opportunity.annualLeasing;
        this.annualIncome = opportunity.annualIncome;
        this.currentAnnualProfit = opportunity.currentAnnualProfit;
        this.prices = opportunity.prices;
        this.bricks = opportunity.bricks;
        this.bricksOnSaleByInvestor = opportunity.bricksOnSaleByInvestor;
        this.maximumBricksToBuy = opportunity.maximumBricksToBuy;
    }
    getOpportunityTypeName() {
        return PROPERTY_OPPORTUNITIES_NAMES[this.opportunityType];
    }
    getStrategyName() {
        return PROPERTY_STRATEGIES_NAME[this.investmentStrategy];
    }
    getPropertyTypeName() {
        return PROPERTY_TYPES[this.type];
    }
}
export default BestOpportunity;
